import { Component } from "react"
import { getCellValue } from "../../../common/ag-grid-utils"
import { dateValueFormatter } from "../../../common/ag-grid-value-formatters"
import { DATE_ONLY_FORMAT, TIME_FORMAT } from "../../../common/constants"

class TkTimeCardTitleCellRenderer extends Component {
    refresh() {
        return false
    }

    render() {
        const value = getCellValue(this.props)

        const { features } = this.props.context.currentUser
        // value should never be undefined, but occasionally it is (probably while the page
        // is still loading), so catch that here
        if (!value) {
            return <div className="group-cell"></div>
        }

        const title = this.props.valueFormatter({ value })
        const date = dateValueFormatter({ value: value.start_time }, DATE_ONLY_FORMAT)
        const startTime = dateValueFormatter({ value: value.start_time }, TIME_FORMAT)
        const endTime = dateValueFormatter({ value: value.end_time }, TIME_FORMAT)

        if (value.id === -1)
            return (
                <div className="group-cell">
                    <div className="group-cell-title">--</div>
                </div>
            )
        return (
            <div className="group-cell">
                <div>
                    <div className="group-cell-title">{title}</div>
                    <div className="group-cell-text">
                        {features.disable_work_shift_start_stop_times
                            ? date
                            : `${date} \u2022 ${startTime} - ${endTime}`}
                    </div>
                </div>
            </div>
        )
    }
}

export default TkTimeCardTitleCellRenderer
